<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { vOnClickOutside } from '@vueuse/components';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  selectedTeam: {
    type: Object,
    default: null,
  },
  teams: {
    type: Array,
    default: () => [],
  },
  showTeamsDropdown: {
    type: Boolean,
    required: true,
  },
  hasErrors: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selectTeam', 'clearTeam', 'toggleDropdown']);

const { t } = useI18n();

const teamMenuItems = computed(() =>
  props.teams.map(team => ({
    label: team.name,
    value: team.id,
    action: 'team',
    ...team,
  }))
);
</script>

<template>
  <div
    class="flex items-center flex-1 w-full gap-3 px-4 py-3 overflow-y-visible"
  >
    <label class="mb-0.5 text-sm font-medium text-n-slate-11 whitespace-nowrap">
      {{ t('COMPOSE_NEW_CONVERSATION.FORM.SECTOR_SELECTOR.LABEL') }}
    </label>
    <div
      v-if="selectedTeam"
      class="flex items-center gap-1.5 rounded-md bg-n-alpha-2 truncate ltr:pl-3 rtl:pr-3 ltr:pr-1 rtl:pl-1 h-7 min-w-0"
    >
      <span class="text-sm truncate text-n-slate-12">
        {{ selectedTeam.name }}
      </span>
      <Button
        variant="ghost"
        icon="i-lucide-x"
        color="slate"
        size="xs"
        class="flex-shrink-0"
        @click="emit('clearTeam')"
      />
    </div>
    <div
      v-else
      v-on-click-outside="() => emit('toggleDropdown', false)"
      class="relative flex items-center h-7"
    >
      <Button
        :label="t('COMPOSE_NEW_CONVERSATION.FORM.SECTOR_SELECTOR.BUTTON')"
        variant="link"
        size="sm"
        :color="hasErrors ? 'ruby' : 'slate'"
        :disabled="disabled"
        class="hover:!no-underline"
        @click="emit('toggleDropdown', !showTeamsDropdown)"
      />
      <DropdownMenu
        v-if="teamMenuItems.length > 0 && showTeamsDropdown"
        :menu-items="teamMenuItems"
        class="ltr:left-0 rtl:right-0 z-[100] top-8 overflow-y-auto max-h-56 w-fit max-w-sm dark:!outline-n-slate-5"
        @action="emit('selectTeam', $event)"
      />
    </div>
  </div>
</template>
